module.exports = __webpack_public_path__ + "img/bg_hero.f1591f1e.svg";